import module from 'module';

import templateUrl from './pawn-renewal-ticket.template.html';
import './pawn-renewal-ticket.style.less';

class PawnRenewalTicketViewComponent {
  constructor($route, $timeout, http, nav, printService) {
    this.$route = $route;
    this.$timeout = $timeout;
    this.http = http;
    this.nav = nav;
    this.printService = printService;
  }

  $onInit() {
    const pawnId = this.$route.current.params['pawnId'];

    this.$timeout(() => {
      this.http.post(`/print/PAWN_RENEWAL/json`, {pawnId: pawnId})
        .success(doc => {
          this.doc = doc;
          return this.printService.printToContainer(doc, {
            autoPrint: false,
            backgroundEnabled: true,
            container: $('.iframe-preview')
          });
        })
        .error(error => {
          console.error('Failed to fetch pawn renewal ticket: ', error);
        });
    });
  }

  redirectBack() {
    this.nav.back();
  }

  print() {
    this.printService.printToContainer(this.doc, {
      autoPrint: true,
      backgroundEnabled: false,
      container: $('.iframe-invisible')
    });
  }

}

module.component('pawnRenewalTicketView', {
  templateUrl: templateUrl,
  controller: PawnRenewalTicketViewComponent
})